import { createApiService } from './api';

// Payments (billing service base)
// Uses nginx reverse proxy path for all environments (K8s, Docker, local via Vite)
const PAYMENT_API_BASE_URL = import.meta.env.VITE_PAYMENT_API_BASE_URL || '/api/payment';

export const paymentApiService = createApiService(PAYMENT_API_BASE_URL);

